import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { action: "" }
const _hoisted_2 = {
  class: "modal-card",
  style: {"width":"auto"}
}
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "modal-card-title" }
const _hoisted_5 = { class: "modal-card-body" }
const _hoisted_6 = { class: "modal-card-foot" }
const _hoisted_7 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('settings.changePasswordTitle')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "delete",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createVNode(_component_b_field, {
          label: _ctx.$t('settings.newPassword'),
          "label-position": _ctx.labelPosition,
          type: _ctx.v$.newPassword.$error ? 'is-danger' : '',
          message: _ctx.v$.newPassword.$error ? _ctx.v$.newPassword.$errors[0].$message : null
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_input, {
              type: "password",
              modelValue: _ctx.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event)),
              "password-reveal": "",
              placeholder: _ctx.$t('settings.newPasswordPlaceholder')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label", "label-position", "type", "message"]),
        _createVNode(_component_b_field, {
          label: _ctx.$t('settings.newPasswordConfirm'),
          "label-position": _ctx.labelPosition,
          type: _ctx.v$.newPasswordConfirmed.$error ? 'is-danger' : '',
          message: _ctx.v$.newPasswordConfirmed.$error ? _ctx.v$.newPasswordConfirmed.$errors[0].$message : null
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_input, {
              type: "password",
              modelValue: _ctx.newPasswordConfirmed,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPasswordConfirmed) = $event)),
              "password-reveal": "",
              placeholder: _ctx.$t('settings.newPasswordConfirmPlaceholder')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label", "label-position", "type", "message"])
      ]),
      _createElementVNode("footer", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_b_button, {
            label: _ctx.$t('global.close'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
          }, null, 8, ["label"]),
          _createVNode(_component_b_button, {
            label: _ctx.$t('settings.changePassword'),
            type: "is-primary",
            disabled: _ctx.v$?.$error || !_ctx.v$.newPassword.$dirty || !_ctx.v$.newPasswordConfirmed.$dirty,
            onClick: _ctx.changePassword
          }, null, 8, ["label", "disabled", "onClick"])
        ])
      ])
    ])
  ]))
}